import React from "react";
import { Redirect } from "react-router-dom";
import i18next from "i18next";

import fr_CA from "./i18n/fr_CA";
import en_CA from "./i18n/en_CA";

i18next.addResourceBundle("fr-CA", "measurementUnitsApp", fr_CA);
i18next.addResourceBundle("en-CA", "measurementUnitsApp", en_CA);

export const measurementUnitsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  name: "measurementUnits",
  auth: "item_management",
  routes: [
    {
      path: "/app/measurementUnits/item/:itemId",
      component: React.lazy(() => import("./views/Item")),
    },
    {
      path: "/app/measurementUnits/list",
      component: React.lazy(() => import("./views/List")),
    },
    {
      path: "/app/measurementUnits",
      component: () => <Redirect to="/app/measurementUnits/list" />,
    },
  ],
};
